import { faIcon } from "@utils/faIcon"

import { IconButton } from "@atoms/index"

export default function TimelineViewTechniciansBarHeader() {
    return (
        <div className="job-timeline-view__technicians-bar__header">
            <span className="job-timeline-view__technicians-bar__header-text">Technicians</span>
            <IconButton
                className="job-timeline-view__technicians-bar__header-toggle-button jsJobTechniciansBarColumnHeaderToggle"
                icon={faIcon({ name: "arrow-left-to-line", style: "regular" })}
                variant="ghost"
                size="md"
                aria-label="Show or hide technicians"
                onClick={() => null}
            />
        </div>
    )
}
